export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  { width: 40, align: 'center', fixed: 'left', type: 'checkbox' },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 80,
    slots: {
      default: 'opt'
    }
  },
  {
    field: 'orderNo',
    title: '订单编号',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    slots: {
      default: 'orderNo'
    }
  },
  {
    field: 'bizBillNo',
    title: 'ERP/WMS单号',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'orderBizStatusName',
    title: '业务状态',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'transportModeName',
    title: '运输模式',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'orderStatusName',
    title: '订单状态',
    headerAlign: 'center',
    align: 'center',
    width: 80
  },
  {
    field: 'custShortName',
    title: '客户',
    headerAlign: 'center',
    align: 'left',
    width: 140,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'showOrderDate',
    title: '客户托运日期',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'contractName',
    title: '合同名称',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'chargeUnitName',
    title: '计费单位',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'orderFreight',
    title: '收入运费',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'orderFee',
    title: '收入费用',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'totalAmount',
    title: '收入总价',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'contractFreight',
    title: '合同运费',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'contractFee',
    title: '合同费用',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'contractAmount',
    title: '合同收入',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'orderTypeName',
    title: '订单类型',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'bizTypeName',
    title: '业务类型',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'totQty',
    title: '总件数',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'totInWeight',
    title: '总收入重量KG',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'totInVolume',
    title: '总收入体积m³',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'totValue',
    title: '总货值',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },

  {
    field: 'wayBillNo',
    title: '运单号',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'vehicleModelName',
    title: '车型',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'vehicleLengthName',
    title: '车长',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'vehicleLoad',
    title: '载重',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'vehicleVolume',
    title: '载方',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },

  {
    field: 'orderSourceName',
    title: '订单来源',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'orgName',
    title: '组织机构',
    headerAlign: 'center',
    align: 'left',
    width: 180,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'pickupName',
    title: '发货方',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'pickupProvinceName',
    title: '发货省份',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'pickupCityName',
    title: '发货城市',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'pickupDistrictName',
    title: '发货区县',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'pickupAddress',
    title: '发货地址',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'pickupContactName',
    title: '发货联系人',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'pickupContactMobile',
    title: '发货手机号',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'pickupContactPhone',
    title: '发货联系电话',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'pickupContactEmail',
    title: '发货联系邮件',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'pickupRemark',
    title: '发货备注',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveName',
    title: '收货方',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveProvinceName',
    title: '收货省份',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveCityName',
    title: '收货城市',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveDistrictName',
    title: '收货区县',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveAddress',
    title: '收货地址',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveContactName',
    title: '收货联系人',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveContactMobile',
    title: '收货手机号',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveContactPhone',
    title: '收货电话',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveContactEmail',
    title: '收货邮件',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveRemark',
    title: '收货备注',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },

  {
    field: 'pickDatetimeBegin',
    title: '提货时间开始',
    headerAlign: 'center',
    align: 'center',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'pickDatetimeEnd',
    title: '提货时间截止',
    headerAlign: 'center',
    align: 'center',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveDatetimeBegin',
    title: '收货时间开始',
    headerAlign: 'center',
    align: 'center',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'receiveDatetimeEnd',
    title: '收货时间截止',
    headerAlign: 'center',
    align: 'center',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'transportHours',
    title: '运输时效',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'createTime',
    title: '创建时间',
    headerAlign: 'center',
    align: 'center',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'createByName',
    title: '创建人',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'modifyTime',
    title: '修改时间',
    headerAlign: 'center',
    align: 'center',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'modifyByName',
    title: '修改人',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  }
]
